// export const publicPath = 'https://goldfish-app-v4mgr.ondigitalocean.app/';
export const publicPath = "https://isans-api.inecnigeria.org/";
